import type { ReactNode } from 'react';

type FormSectionProps = {
  readonly title: string;
  readonly children: ReactNode;
};

export function FormSection({ title, children }: FormSectionProps) {
  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-xs font-medium tracking-wide text-muted-foreground uppercase">{title}</h3>
      {children}
    </section>
  );
}
